import { useSelector, useDispatch } from "react-redux";
import { toast } from "Layout/slice";
import { getPartnerships, connectPartnership } from "features/Account/service";
import { parseErrorMessage } from "utils";
import { userDetailSelect } from "Layout/slice/selector";
import { useQuery } from "./useQuery";

export const usePartnerships = () => {
  const dispatch = useDispatch();
  const userDetails = useSelector(userDetailSelect);

  const { isLoading, data, refetch } = useQuery({
    queryKey: ["partnerships", userDetails?.id],
    queryFn: async () => {
      const response = await getPartnerships(userDetails.id);
      return response?.partnerships || {};
    },
    enabled: Boolean(userDetails?.id),
  });

  const connect = async (partnershipType, code) => {
    if (!userDetails?.id) {
      dispatch(
        toast({
          type: "error",
          body: "User details not found",
        })
      );
      return { success: false, error: "User details not found" };
    }

    try {
      const response = await connectPartnership(
        userDetails.id,
        partnershipType,
        code
      );
      await refetch();
      dispatch(
        toast({
          type: "success",
          body: "Successfully connected partnership",
        })
      );
      return { success: true, data: response.data };
    } catch (error) {
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
      return {
        success: false,
        error: error.response?.data || "An error occurred",
      };
    }
  };

  return {
    isLoading,
    partnerships: data || {},
    connectPartnership: connect,
    refetchPartnerships: refetch,
  };
};
